import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {}

  show(e) {
    e.preventDefault()
    document.querySelector(this.element.getAttribute("href")).classList.remove("hidden")
  }
}